import { useRouter } from "next/router";
import React, { useEffect } from "react";

export const Navigate = ({ link }: { link?: string }) => {
  const router = useRouter();
  useEffect(() => {
    if (link) {
      router?.push(link);
    }
  }, [link]);
  return <></>;
};
